module.exports = __webpack_public_path__ + "static/animation-map-pin1-fc3d90b1379b64c96eb7e18973182c43.png";